import React, { useState, useEffect } from "react";
import "./ProjectAuthTable.css";
import { useLanguage } from "../../../../../LanguageProvider";
import UniversalTable from "../../../../../components/UniversalTable/UniversalTable";

export default function ProjectAuthTable({
  entities,
  authorizations,
  onPermissionsUpdate,
  role,
}) {
  const { getTranslation } = useLanguage();
  const [selectedPermissions, setSelectedPermissions] = useState({});

  useEffect(() => {
    const initialPermissions = {};
    entities.forEach((entity) => {
      const auth = authorizations.find((auth) => auth.id === entity.id);
      initialPermissions[entity.id] = auth ? auth.authorization : "";
    });
    setSelectedPermissions(initialPermissions);
  }, [entities, authorizations]);

  useEffect(() => {
    if (role) {
      let updatedPermissions = {};
      if (role === "employee") {
        entities.forEach((entity) => (updatedPermissions[entity.id] = "read"));
      } else if (role === "partner" || role === "owner") {
        entities.forEach((entity) => (updatedPermissions[entity.id] = "all"));
      }
      setSelectedPermissions(updatedPermissions);
      onPermissionsUpdate(updatedPermissions);
    }
  }, [role, entities, onPermissionsUpdate]);

  const onPermissionChange = (entityId, permission) => {
    if (role === "owner") return;

    setSelectedPermissions((prev) => {
      const updatedPermissions = { ...prev };

      if (prev[entityId] === permission) {
        delete updatedPermissions[entityId]; // Seçiliyse kaldır
      } else {
        updatedPermissions[entityId] = permission; // Yeni seçim yapıldıysa güncelle
      }

      onPermissionsUpdate(updatedPermissions);
      return updatedPermissions;
    });
  };

  const columns = [
    { key: 'title', header: getTranslation("title"), width: '40%' },
    {
      key: 'read', header: getTranslation("view"),
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedPermissions[row.id] === 'read'}
          onChange={() => onPermissionChange(row.id, 'read')}
          disabled={role === 'owner'}
        />
      ),
      align: 'center'
    },
    {
      key: 'edit', header: getTranslation("edit"),
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedPermissions[row.id] === 'edit'}
          onChange={() => onPermissionChange(row.id, 'edit')}
          disabled={role === 'owner'}
        />
      ),
      align: 'center'
    },
    {
      key: 'all', header: getTranslation("allAccess"),
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedPermissions[row.id] === 'all'}
          onChange={() => onPermissionChange(row.id, 'all')}
          disabled={role === 'owner'}
        />
      ),
      align: 'center'
    },
  ];

  return (
    <UniversalTable
      data={entities || []}
      columns={columns}
      containerClassName="table-container"
      tableClassName="table"
      emptyText={getTranslation("noData")}
    />
  );
}
